import { ActionSheetItem, DropListButton, ListItemText } from '@ketch-com/deck'
import { PermitHistoryDTO } from '@ketch-com/figurehead'
import React from 'react'
import { formatDateTimeFromUnix } from 'utils/helpers/dateTime'

type HistoricalPermitDatePickerProps = {
  value: PermitHistoryDTO | null
  options: PermitHistoryDTO[]
  onChange: (permitDateTime: PermitHistoryDTO) => void
}

/**
 * Component for picking from a list of historical permit datetimes.
 * @param value - Selected permit datetime
 * @param options - Array of permit date times
 * @param onChange - Function to handle permit date time change
 * @returns Historical permit date picker component
 */
export const HistoricalPermitDatePicker: React.FC<HistoricalPermitDatePickerProps> = ({ value, options, onChange }) => {
  return (
    <DropListButton
      size="small"
      width="205px"
      options={options}
      placeholder="Select Historical Permit"
      getOptionLabel={option => formatDateTimeFromUnix(option.collectedAt)}
      isOptionEqualToValue={(option, value) => {
        return option.collectedAt === value.collectedAt
      }}
      onChange={(_, newValue) => {
        if (newValue) {
          onChange(newValue)
        }
      }}
      disableClearable
      value={value || undefined}
      renderOption={(props, option) => {
        const isSelected = option.collectedAt === value?.collectedAt

        return (
          <ActionSheetItem selected={isSelected} {...props} key={`${option.transactionID}-${option.collectedAt}`}>
            <ListItemText selected={isSelected}>{formatDateTimeFromUnix(option.collectedAt)}</ListItemText>
          </ActionSheetItem>
        )
      }}
    />
  )
}
